<!--
 * @Description  : 安招采服务管理 -- 移动认证管理下方内容
 * @Author       : 王帅
 * @Date         : 2026-07-14 15:35:46
 * @LastEditors  : 王帅
 * @LastEditTime : 2026-07-14 17:09:07
 * @FilePath     : \ngs_platform_manage_admin\src\views\operation-management\platform-services\azc-components\tab-user.vue
-->
<template>
	<div class="tab-content">
		<div class="content-header">
			<div class="btn-box">
				<el-button type="primary" class="btn-blue" size="small" @click="doExport">
					导出
				</el-button>
			</div>
		</div>
		<!-- 非请求参数 正常查看 -->
		<div class="w-table-layout w-table-page">
			<div class="w-table-content bd-table">
				<el-table :data="filterData" height="100%" highlight-current-row row-key="id" border ref="table" v-if="!loading">
					<el-table-column type="index" label="序号" align="center" width="70"></el-table-column>
					<el-table-column prop="goodsName" label="服务" header-align="center" width="170" show-overflow-tooltip> </el-table-column>
					<el-table-column prop="goodsCode" label="服务类型" align="center" width="120" show-overflow-tooltip>
						<template #default="{ row }">
							<span>{{ statusText('goodsCode', row.goodsCode) }}</span>
						</template>
					</el-table-column>
					<el-table-column label="权益使用者" header-align="center">
						<el-table-column prop="userName" label="姓名" header-align="center" width="120" show-overflow-tooltip></el-table-column>
						<el-table-column prop="userIdCard" label="身份证号" header-align="center" width="170" show-overflow-tooltip></el-table-column>
						<el-table-column prop="phone" label="手机号" header-align="center" width="150" show-overflow-tooltip></el-table-column>
					</el-table-column>
					<el-table-column
						prop="payCompanyName"
						label="开通单位"
						header-align="left"
						min-width="200"
						show-overflow-tooltip
					></el-table-column>
					<el-table-column
						prop="payCompanyCreditcode"
						label="税号"
						header-align="left"
						min-width="180"
						show-overflow-tooltip
					></el-table-column>
					<el-table-column prop="payUserName" label="开通人" align="left" width="120" show-overflow-tooltip></el-table-column>
					<el-table-column prop="goodsMoney" label="支付金额（元）" align="right" width="120" show-overflow-tooltip></el-table-column>
					<el-table-column prop="payTime" label="开通时间" align="left" width="150" show-overflow-tooltip></el-table-column>
					<el-table-column prop="checkTime" label="核销认证时间" align="left" width="150" show-overflow-tooltip></el-table-column>
					<el-table-column prop="userTime" label="服务有效期" align="left" width="220" show-overflow-tooltip> </el-table-column>
					<el-table-column prop="payStatus" label="状态" align="left" width="100" show-overflow-tooltip>
						<template #default="{ row }">
							<span>{{ statusText('payStatus', row.payStatus) }}</span>
						</template>
					</el-table-column>
					<el-table-column align="left" width="180" label="操作">
						<template #default="{ row }">
							<el-button type="primary" size="small" round plain class="table-btn" @click="handleBtn('detail', row)">
								查看
							</el-button>
							<!-- row.payStatus == 4 -->
							<el-button
								type="primary"
								size="small"
								v-if="row.payStatus == 4"
								round
								plain
								class="table-btn"
								@click="handleBtn('closePay', row)"
							>
								关闭服务
							</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="w-table-footer">
				<el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page="currentPage"
					:page-sizes="pageList"
					:page-size="pageSize"
					:total="total"
					layout="total, sizes, prev, pager, next, jumper"
				>
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import { exportPlus } from 'utils/tools'
import * as Api from '@/api/modules/platform-service/index'

export default {
	name: '',
	props: {
		searchForm: {
			type: Object,
			default: () => {
				return {}
			}
		}
	},
	data() {
		return {
			filterData: [],
			loading: false,
			tableShow: true,
			pageList: [10, 20, 30, 50, 100], // 显示条数数组
			currentPage: 1, // 当前页码
			pageSize: 10, // 当前显示条数
			total: 0 // 当前总条数
		}
	},
	methods: {
		//获得列表数据
		getData(isBack) {
			this.filterData = []

			let params = Object.assign({}, this.searchForm)
			if (params.dateArr && params.dateArr.length > 0) {
				params.payStartTime = params.dateArr[0] + ' 00:00:00'
				params.payEndTime = params.dateArr[1] + ' 23:59:59'
			} else {
				params.payStartTime = ''
				params.payEndTime = ''
			}
			delete params.dateArr

			this.loading = true

			// 分页参数
			params.current = this.currentPage
			params.size = this.pageSize

			Api.selectUserFeePage(params)
				.then((res) => {
					this.filterData = res.data.records
					this.currentPage = parseInt(res.data.current)
					this.total = parseInt(res.data.total)
					this.pageSize = parseInt(res.data.size)
				})
				.catch((err) => {})
				.finally(() => {
					this.loading = false
					setTimeout(() => {
						this.$refs.table ? this.$refs.table.doLayout() : ''
					}, 500)
				})
		},

		// 切换显示条数
		handleSizeChange(val) {
			this.pageSize = val
			this.getData()
		},

		//切换当前页码
		handleCurrentChange(val) {
			this.currentPage = val
			this.getData()
		},

		// 重置
		doReset() {
			this.pageSize = 10
			this.currentPage = 1
			this.getData()
		},

		//按钮操作
		handleBtn(type, row) {
			row.payStatusText = this.statusText('payStatus', row.payStatus)
			this.$emit('openDetail', { type, row })
		},

		//导出
		doExport() {
			if (this.filterData.length == 0) {
				this.$message.warning('暂无要导出的数据！')
				return
			}
			let params = Object.assign({}, this.searchForm)
			let path = '/ngsBid/exportVerifiedUserFeePage'
			exportPlus(path, params)
		}
	},
	computed: {
		...mapState('menu', {
			roleBtns: (state) => state.roleBtns
		}),

		...mapState('user', { userInfo: (state) => state.userInfo }),

		// 支付状态码表
		statusArr() {
			let arr = [
				{ value: '0', label: '生效中' },
				{ value: '1', label: '已失效' },
				{ value: '2', label: '已关闭' },
				{ value: '3', label: '待生效' },
				{ value: '4', label: '待核销' }
			]

			return arr
		},

		// 不同码表展示的文字
		statusText() {
			let text = ''
			let that = this
			return function(type, value) {
				switch (type) {
					// 服务类型
					case 'goodsCode':
						text = value !== '' ? ['新办', '续费'][parseFloat(value)] : ''
						break
					// 状态
					case 'payStatus':
						let item = that.statusArr.find((x) => parseFloat(x.value) === parseFloat(value))
						text = item && item.label ? item.label : ''
						break
				}
				return text
			}
		},

		// 日期选择快捷选项
		pickerOptions() {
			let that = this
			// 本日
			let dayStart = this.$utils.getWhatDay(new Date(), 0, 'first')
			let dayEnd = this.$utils.getWhatDay(new Date(), 0, 'last')
			// 本月
			let monthStart = this.$utils.getWhatMonth(new Date(), 0, 'first')
			let monthEnd = this.$utils.getWhatMonth(new Date(), 0, 'last')
			// 本年
			let yearStart = this.$utils.getWhatYear(new Date(), 0, 'first')
			let yearEnd = this.$utils.getWhatYear(new Date(), 0, 'last')
			return {
				shortcuts: [
					{
						text: '今日',
						onClick(picker) {
							console.log('😍 ~ picker:', picker)
							picker.$emit('pick', [dayStart, dayEnd])
							setTimeout(() => {
								that.searchName()
							}, 200)
						}
					},
					{
						text: '本月',
						onClick(picker) {
							picker.$emit('pick', [monthStart, monthEnd])
							setTimeout(() => {
								that.searchName()
							}, 200)
						}
					},
					{
						text: '本年',
						onClick(picker) {
							picker.$emit('pick', [yearStart, yearEnd])
							setTimeout(() => {
								that.searchName()
							}, 200)
						}
					},
					{
						text: '最近一周',
						onClick(picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
							picker.$emit('pick', [start, end])
							setTimeout(() => {
								that.searchName()
							}, 200)
						}
					},
					{
						text: '最近三个月',
						onClick(picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
							picker.$emit('pick', [start, end])
							setTimeout(() => {
								that.searchName()
							}, 200)
						}
					}
				]
			}
		}
	}
}
</script>
<style scoped lang="less">
.tab-content {
	height: 100%;
	display: flex;
	flex-direction: column;

	.content-header {
		padding: 10px 0;
		display: flex;
		justify-content: space-between;

		.btn-box {
			margin-left: auto;
		}
	}

	.w-table-layout {
		flex: 1;
	}
}
</style>
